import mapValues from 'lodash/mapValues'
import orderBy from 'lodash/orderBy'
import { splitAdmissionsPeriod } from '../../conduct/generators'
import { createAdmissionsSlotsFrom, removeHealthProceduresOfAdmissions } from '../../mappers'
import { IHealthProcedures, ITimelineGeneral } from '~/interfaces'
import {
  groupByYear,
  groupByMonth,
  byTypeExceptAdmission,
  filterHealthProceduresPer,
  byTypeEqualToAdmission,
  getMonthName
} from '~/utils'

export const mapperTimelineViewByMonthsFrom = (
  healthProcedures: IHealthProcedures[]
): ITimelineGeneral.IMonthlyTimelineData => {
  const healthProceduresWithoutAdmissions = filterHealthProceduresPer(healthProcedures, byTypeExceptAdmission)
  const admissions = filterHealthProceduresPer(healthProcedures, byTypeEqualToAdmission)
  const admissionSlots = createAdmissionsSlotsFrom(admissions, healthProceduresWithoutAdmissions)

  const splitAdmissionsSlotsPerMonth = splitAdmissionsPeriod(admissionSlots, 'months')
  const independentHealthProcedures = removeHealthProceduresOfAdmissions(healthProceduresWithoutAdmissions, admissions)
  const orderSlots = orderBy([...splitAdmissionsSlotsPerMonth, ...independentHealthProcedures], ['startDate'], ['asc'])
  const groupedByMonth = groupByMonth(orderSlots)

  const groupedMonthsStructured = mapValues(
    groupedByMonth,
    (groupedHealthProcedure: IHealthProcedures[], key: string) => {
      const monthName = getMonthName(groupedHealthProcedure[0].startDate)

      return {
        id: monthName,
        startDate: key,
        monthsRowSlotsTotal: groupedHealthProcedure.length,
        rowSlots: groupedHealthProcedure
      }
    }
  ) as ITimelineGeneral.IMonthlyRowSlotsWrapper

  const monthsGroupedByYear = groupByYear(Object.values(groupedMonthsStructured))

  const groupedYearsStructured = mapValues(
    monthsGroupedByYear,
    (monthRegister: ITimelineGeneral.IMonthlyRowSlotsWrapper[], key: string) => {
      const monthRowSlotsSunInYear = monthRegister.reduce(
        (acc, month) => (acc = Number(acc) + Number(month.monthsRowSlotsTotal)),
        0
      )

      return {
        id: key,
        months: monthRegister.reverse(),
        yearsRowSlotsTotal: monthRowSlotsSunInYear
      }
    }
  ) as ITimelineGeneral.IMonthlyYearsSlotsWrapper

  return {
    timelineId: new Date(healthProcedures[0]?.startDate).getTime(),
    years: Object.values(groupedYearsStructured).reverse()
  }
}
